const urlGroupMap = [
    {
        groupName: '/fsda',
        groupUrls: [
            '/app/bootImage.json', //	启动图	C	new	【降级相关】
            '/app/loadPic.json', //	轮播图	C
            '/app/iconList.json', //	网点icon字典	C
            '/app/bannerList.json', //	首页banner列表	C
            '/s/userCenter/listActivity.json', //	活动中心	C
            '/parking/recommendReturnParkingList.json', //	常用还车网点	C
            '/app/update.json', //检查更新	C
        ],
    },
    {
        groupName: '/app',
        groupUrls: [
            '/app/startUp.json', //	启动	R	new	app分组
            '/app/appRegist/smsCodeV1.json', //	app注册登陆短信验证码	R
            '/app/deleteUser/smsCodeV1.json', //	发送账号注销验证码	R
            '/app/cityState.json', //	城市状态	R
        ],
    },
    {
        groupName: '/user',
        groupUrls: [
            '/user/tokenValidate.json', //	虚拟登录	R	new	user分组
            '/user/login.json', //	登录	R
            '/user/logout.json', //	退出登录	R
            '/user/userBalanceDetail.json', //	交易明细	R
            '/user/relationToUserValidate.json', //	检测身份证件提交次数	R
            '/user/userCardLicense.json', //	提交身份证件信息	R
            '/user/userDriverLicense.json', //	提交驾驶证件信息	R
            '/user/obtainIdCardStatus.json', //	（用车前）身份证状态获取	R
            '/user/inHandUpload.json', //	手工上传图片	R
            '/user/updateNewSim.json', //个人中心修改手机号，提交绑定	 	C
            '/user/checkOldSim.json', //个人中心修改手机号 检查老手机号	 	C
            '/user/updateSim.json', //个人中心修改手机号 点击下一步	 	C
        ],
    },
    {
        groupName: '/order',
        groupUrls: [
            '/order/getEvaluateOptionInfo.json', //	获取评价	R	new	order分组
            '/order/detail.json', //	未支付订单	R
            '/order/currentOrder.json', //	当前订单	R
            '/order/confirm.json', //	确认预定	R
            '/order/progressBarByCar.json', //	准备用车进度条	R
            '/order/basicInfo.json', //	取车中静态数据	R
            '/order/dynamicInfo.json', //	取车中动态数据	R
            '/order/shareInfo.json', //	分享信息	R
            // '/order/orderAndPeccancyCountList.json', //  行程列表  R==>挪到o4h5试试
            '/order/orderFeeDetail.json', //	订单费用明细	R
            '/order/prePay.json', //	结单前判断	R
            '/order/updateOrderReturnParking.json', //	修改还车网点	R
            '/order/payAmount.json', //	获取订单支付金额	R
            '/order/saveOrderEvaluate.json', //	新增订单行程评价【订单】	R
            '/order/myTripDetail.json', //	行程详情	R
            '/order/allcarTypeList.json', //	 驾驶指南列表查询———查询所有车型 	C
            '/order/drivingGuideList.json', //驾驶指南列表查询 	C
            '/order/itemList.json', //我的客服-首页	 	C
            '/order/classifyDetail.json', //我的客服 分类详情列表	 	C
            '/order/problemDetail.json', //我的客服 分类详情信息展示	 	C
            '/order/whtherUseful.json', //我的客服 都统问题是计解决	 	C
            '/order/feedbackUserList.json', //意见反馈	 	C
            '/order/orderAndPeccancyCountList.json', //  行程列表  R==>从order挪过来
        ],
    },
    {
        groupName: '/orderBill',
        groupUrls: [
            '/orderBill/preBill.json', //	预结算	R	new	orderBill分组
            '/orderBill/orderActivity.json', //	订单活动	R
            '/orderBill/priceInfo.json', //	订单费用	R
            '/orderBill/orderCoupon.json', //	订单优惠券	R
        ],
    },
    {
        groupName: '/orderTrigger',
        groupUrls: [
            '/orderTrigger/cancel.json', //	取车中取消订单	R	new	orderTrigger分组
            '/orderTrigger/closeDoorPay.json', //	取车中结算订单请求接口	R
            '/orderTrigger/uploadCarBeforeImage.json', //	上传用车前拍照图片	R
            '/orderTrigger/findCar.json', //	声音寻车	R
            '/orderTrigger/openDoor.json', // 开车门 R
            '/orderTrigger/closeDoor.json', //	关车门	R
            '/orderTrigger/pay.json', //	结单	R
            '/orderTrigger/freePay.json', //	免费还车	R
            '/orderTrigger/userFaceRecognitionByOrder.json', //	上传人脸识别图片	R	 	upload image

        ],
    },
    {
        groupName: 'coupon',
        groupUrls: [
            '/coupon/myCoupon.json', //	我的优惠券	R	new	coupon分组
            // '/coupon/activeCoupon.json', //	兑换优惠券	R
        ],
    },
    {
        groupName: '/car',
        groupUrls: [
            '/car/changeCarCard.json', //	属地化运营规则	R	new	car分组
            '/car/searchCondition.json', //	车辆筛选	R
            '/car/feeType.json', //	车型计价规则	R
        ],
    },
    {
        groupName: '/parking',
        groupUrls: [
            '/parking/confirmReturnParking.json', //	确认还车网点	R	new	parking分组
            '/parking/businessList.json', //	首页商圈列表	R
            '/parking/eleFenceList.json', //	电子围栏	R
            '/parking/getCityMapCfg.json', //	根据城市编码，获取城市地图缩放级别	R
            '/parking/parkingInfo.json', //	取车场信息详细数据	R
            '/parking/confirmTakeParking.json', //	网点车辆列表	R	 	single-rate-limiting
            '/parking/returnParkingList.json', //  可还车网点列表	R	 	single-rate-limiting
            '/parking/parkingList.json', //	网点列表	R	 	single-rate-limiting
            '/parking/cityList.json', //	首页城市列表	R	 	single-rate-limiting
            '/parking/carCount.json', //	首页网点车辆数	R	 	single-rate-limiting
        ],
    },
    {
        groupName: '/s',
        groupUrls: [
            '/s/userCenter/listActivity.json', //	列出活动	R	new	s分组
            '/s/order/peccancyList.json', //	我的行程-费用交纳	R
            '/s/userCenter/balanceQuery.json', //	钱包	R
            '/s/userCenter/getInfo.json', //	 获取用户信息	R
            '/s/userCenter/center.json', //	个人中心	R
            '/s/userCenter/deleteUserCheck.json', //	检查是否能注销	R
            '/s/userCenter/deleteUser.json', //	账户注销	R
            '/s/userCenter/verifyInfo.json', //	请求三证状态	R
            '/s/upgrade/upgradeList.json', //	履约保证金列表	R
            '/s/userCenter/queryMyOrderTotalInfo.json', //	总里程总时长总订单,未支付订单	R
            '/s/userCenter/infoSetting.json', //	个人信息设置	R
            '/s/userCenter/getUserCreditScore.json', //	获取信用分*	R
        ],
    },
    {
        groupName: '/idCard',
        groupUrls: [
            '/idCard/auth.json', //	身份证识别	R	new	idCard分组
        ],
    },
    {
        groupName: '/BLE',
        groupUrls: [
            '/BLE/bluetoothStrEncryption.json', //	蓝牙申请密钥	R	new	bluetooth分组
            '/BLE/bluetoothDataReport.json', //	蓝牙数据上报	R
        ],
    },
    {
        groupName: '/problem',
        groupUrls: [
            '/problem/userProblemOrderList.json', //	 	R	new	【problem】分组
            '/problem/getCustomerProblemType.json', //	 	R
            '/problem/submitCustomerReportProblem.json', //	 	R
            '/problem/getCustomerReportTemplateDetail.json', //	 	R
        ],
    },
    {
        groupName: '/pca',
        groupUrls: [
            '/order/chargePayAmount.json', //	获取充值支付列表	C	old	pca分组，如果app端配置s，需要掐掉
            '/order/chargePayFee.json', //	充值支付	C
            '/order/chargePayResult.json', //	充值支付结果查询	C
            '/order/payFee.json', //	订单支付	C
            '/order/payResult.json', //	订单支付结果查询	C
            '/deposit/payAmount.json', //	基础履约保证金支付方式及金额	C
            '/deposit/payFee.json', //	基础履约保证金支付	C
            '/deposit/payResult.json', //	基础履约保证金支付结果查询	C
            '/upgrade/payTypeAndAmount.json', //	pro履约保证金支付方式及金额	C
            '/upgrade/pay.json', //	pro履约保证金支付	C
            '/upgrade/depositDetail.json', // 履约保证金明细	C
            '/upgrade/payResult.json', //	pro履约保证金支付结果查询	C
            '/order/peccancyPayAmountNew.json', //	获取违章支付金额	C
            '/order/peccancyPayFeeNew.json', //	违章支付	C
            '/order/peccancyPayResult.json', //	违章支付结果查询	C
        ],
    },
    {
        groupName: '/pcb',
        groupUrls: [
            '/sesameCredit/noPwdStatus.json', //	查看免密状态	C	old	pcb分组，如果app端配置s，需要掐掉
            '/sesameCredit/closeNoPwd.json', //	关闭免密支付	C
            '/freeswitch/getZMCheckInNotify.json', //	芝麻信用签约—开启免密支付开关接口	C
            '/sesameCredit/zhimaInfo.json', //	芝麻信用	C
            '/sesameCredit/applyFreeDeposit.json', //	芝麻免履约保证金入口进入时验证	C
            '/sesameCredit/appZhimaCredit.json', //	快登回调token	C
            '/deposit/refundApply.json', //	退基础履约保证金	C
            '/upgrade/refundApply.json', //	退舒适型履约保证金	C
        ],
    },
    {
        groupName: '/pcc',
        groupUrls: [
            '/user/getCreditCardInfo.json', //	信用卡列表	C	old	pcc分组，如果app端配置s，需要掐掉
            '/user/recommendPoint.json', //	推荐建点	C
            // '/app/updateSim/smsCodeV1.json', //	修改手机号，登陆短信验证码	C	 	这个接口是 H5 在用
            '/car/confirmPage.json', //	确认预定页面	C
            '/car/remindUser.json', //	有车提醒	C
            '/order/orderGPS.json', //	订单轨迹	C
            '/car/carOperationManual.json', //	驾驶指南	C
            '/order/orderPicture.json', //	验车单照片（老接口）	C
            '/user/userValidateFace.json', //	资质认证-人脸识别图片上传	C	 	upload image
        ],
    },
    {
        groupName: '/osda',
        groupUrls: [
            '/user/pushToken.json', //  更新pushtoken	C	old	osda分组，【降级相关】
            '/share/shareRedEnvelope.json', //	分享红包	C
            '/app/updateSim/getPicCode.json', //  修改手机号时获取图形验证码	C
        ],
    },
    {
        groupName: '/fiv',
        groupUrls: [
            '/app/appRegist/getPicCode.json', //  app注册登陆图形验证码 C	new	fiv分组，not jwt
            '/app/deleteUser/getPicCode.json', //	获取账号注销图形验证码	C	 	not jwt,20180831
        ],
    },
    {
        groupName: '/o4h5',
        groupUrls: [],
    },
    {
        groupName: '/peccancy',
        groupUrls: [
            '/peccancy/list.json', //	违章列表	C	old	app4.0给H5页面的老api接口分组
            '/peccancy/historyList.json', //	违章历史列表	C
            '/peccancy/peccancyDetail.json', //	违章信息详情 	C
            '/peccancy/peccancyHandlerExplain.json', //自行违章处理说明	 	C
            '/peccancy/peccancyCheck.json', //提交审核	 	C
            '/peccancy/peccancyGoPay.json', //平台代缴-跳转至支付页面	 	C
            '/peccancy/peccancyPay.json', //	 	C
        ],
    },
    {
        groupName: '/h5',
        groupUrls: [
            '/h5/inviteIndex.json', //老拉新h5邀请页	 	C
        ],
    },
    {
        groupName: '/trafficLimitRule',
        groupUrls: [
            '/trafficLimitRule/trafficLimitRuleList.json', //	 	C
        ],
    },
    {
        groupName: '/invoice',
        groupUrls: [
            '/invoice/postInvoiceApply.json', // 电子发票	 	C
            '/invoice/againApplyInvoice.json', //冲开发票 电子	 	C
            '/invoice/invoiceDetail.json', //订单明细     C
            '/invoice/newMyInvoice.json', //我的发票-发票及余额展示    C
            '/invoice/myOrderInvoice.json', //我的订单发票	 	C
            '/invoice/myInvoiceHistory.json', //我的开票记录	 	C
            '/invoice/postInvoiceApply2.json',  //  开纸质发票
        ],
    },
    {
        groupName: '/upgrade',
        groupUrls: [
            '/upgrade/insertRefoundCard.json', //  退还银行卡
        ],
    },
]

/**
 * 接口分组方法
 * @param config
 * 方法用在axios的拦截器里，传入config参数，如果匹配到有分组的url，就直接对config.url进行修改，举个栗子
 * import changeRequestUrl
 * axios.interceptors.request.use(
 *    (config) => {
 *      //接口分组方法
 *      changeRequestUrl(config)
 *      rerutn config
 *    }
 * )
 */
function changeRequestUrl(config) {
    if (config) {
        // console.log(config.baseURL, config.url)
        urlGroupMap.findIndex((el, index) => {
            /*
            * 安卓获取到的baseUrl. "a.com/"
            * IOS获取到的baseUrl. "a.com"
             */
            let requestUrl = config.url.slice(config.baseURL.length - config.baseURL.endsWith("/"))
            // console.log(requestUrl)
            let isFind = el.groupUrls.findIndex(url => url === requestUrl)
            // console.log(config.url)
            if (isFind > -1) {
                let groupName = urlGroupMap[index].groupName
                config.url = config.baseURL + (!requestUrl.indexOf(groupName) ? requestUrl : groupName + requestUrl);
                // if (requestUrl.indexOf(groupName) > -1) {
                //   config.url = config.baseURL + requestUrl
                // } else {
                //   config.url = config.baseURL + groupName + requestUrl
                // }
            }
        })
        // console.log(config.url)
    }
}

changeRequestUrl()

export default changeRequestUrl



// WEBPACK FOOTER //
// src/libs/http/urlGroupMap.js